<template>
    <div class="flex flex-row">
        <SearchForm class="h-full min-h-[619px] w-1/3 shrink-0 border-r border-solid border-grey-40">
        </SearchForm>
        <RouterView class="light-scroll h-full min-h-[619px] grow overflow-y-auto"/>
    </div>
</template>

<script setup lang="ts">
import SearchForm from '@/components/SearchForm.vue'
import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router';
import _ from 'lodash';

const router = useRouter()
const route = useRoute()

onMounted(() => {
    router.replace({ path: '/result' });
})
</script>
